import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import navigation from './navigation.reducer';
import news from './news.reducer';

export default combineReducers({
	navigation,
	router,
	news,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js